import { useRecoilState } from 'recoil';
import * as Atom from '../recoil';
import { useEffect } from 'react';
import useNav from './useNav';

const useRedirect = () => {
  const { navigate } = useNav();
  const [redirectInfo, setRedirectInfo] = useRecoilState(Atom.redirectInfo);

  useEffect(() => {
    const { path } = redirectInfo ?? {};
    if (path) {
      navigate(path);
    }
    return () => {
      setRedirectInfo({ path: '' });
    };
  }, []);
  return {
    isRedirect: !!redirectInfo.path,
  };
};

export default useRedirect;
